




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as links from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query";

@Component({
  components: {
    DataGrid,
  },
})
export default class CarterUtilizationDrillDown extends Vue {
  @Prop() public args!: { locationId: number, userId: number }
  public fields = [
    {name: 'RegionName', title: 'Region', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.region},
    {name: 'SiteName', title: 'Site', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.site},
    {name: 'BuildingName', title: 'Building', dataType: DataType.Text, sort: 1, component: DataGridLink, callback: links.building},
    {name: 'BuildingArea', title: 'Building Area', dataType: 'Number', sort: 1},
    {name: 'OccupiedArea', title: 'Occupied Area', dataType: 'Number', sort: 1},
    {name: 'OccupiedPercentage', title: 'Occupied %', dataType: 'Number', sort: 1, suffix: '%'},
    {name: 'Status', title: 'Status', dataType: 'Text', sort: 1},
  ]

  public async getData(offset: number = 0, limit: number = 250) {
    return await executeQuery("idr", "carterUtilisationPercentageBreakdown",
      {locationId: this.args.locationId},
      this.filterBreakdown,
      offset, limit)
  }

  private filterBreakdown(data: any[]): any {
    const filteredData: any[] = []
    for (const item of data) {
      if (parseInt(item.BuildingArea, 10) === 0) {
        item.OccupiedPercentage = 0
      } else {
        item.OccupiedPercentage = Math.round(item.OccupiedArea / item.BuildingArea * 100)
      }
      filteredData.push({
        RegionId: item.RegionId,
        RegionName: item.RegionName,
        SiteId: item.SiteID,
        SiteName: item.SiteName,
        BuildingId: item.BuildingID,
        BuildingName: item.name,
        BuildingArea: item.BuildingArea,
        OccupiedArea: item.OccupiedArea,
        OccupiedPercentage: item.OccupiedPercentage,
        Status: item.Status,
      })
    }
    return filteredData
  }

}
